import SEAT_CHARACTERISTICS from '../../scripts/constants/seat-characteristics-enum';
import SEAT_UPGRADE_TYPES from '../../scripts/constants/seat-upgrade-types';

import CurrencyValueUIModel from './currency-value';

class SeatChoiceUpsellUIModel {
  constructor({
    code,
    currency,
    farelogixDesignator,
    farelogixPrice,
    points,
    seatCharacteristics,
    type,
  }) {
    this.code = code;
    this.currency = new CurrencyValueUIModel(currency);
    this.farelogixDesignator = farelogixDesignator;
    this.farelogixPrice = farelogixPrice;
    this.isAisleSeat = (seatCharacteristics || []).indexOf(SEAT_CHARACTERISTICS.A) > -1;
    this.isExitRowSeat = (seatCharacteristics || []).indexOf(SEAT_CHARACTERISTICS.EXIT_ROW) > -1;
    this.isMiddleSeat = (seatCharacteristics || []).indexOf(SEAT_CHARACTERISTICS.M) > -1;
    this.isNonRecliningSeat = (seatCharacteristics || []).indexOf(SEAT_CHARACTERISTICS.DO_NOT_RECLINE) > -1;
    this.isWindowSeat = (seatCharacteristics || []).indexOf(SEAT_CHARACTERISTICS.W) > -1;
    this.points = points;
    this.seatCharacteristics = seatCharacteristics || [];
    this.seatUpgradeType = type;
    this.type = type;
  }

  getSeatLabel() {
    const {
      isAisleSeat,
      isMiddleSeat,
      isWindowSeat,
      seatUpgradeType,
    } = this;

    let labelCopyID = '';

    if (seatUpgradeType === SEAT_UPGRADE_TYPES.AMPLUS_UPGRADE) {
      if (isWindowSeat) {
        labelCopyID = 'AM_PLUS_WINDOW_SEAT';
      } else if (isAisleSeat) {
        labelCopyID = 'AM_PLUS_AISLE_SEAT';
      } else if (isMiddleSeat) {
        labelCopyID = 'AM_PLUS_MIDDLE_SEAT';
      } else {
        labelCopyID = 'AM_PLUS_SEAT';
      }
    } else if (seatUpgradeType === SEAT_UPGRADE_TYPES.PREFERRED_UPGRADE) {
      if (isWindowSeat) {
        labelCopyID = 'PREFERRED_WINDOW_SEAT';
      } else if (isAisleSeat) {
        labelCopyID = 'PREFERRED_AISLE_SEAT';
      } else if (isMiddleSeat) {
        labelCopyID = 'PREFERRED_MIDDLE_SEAT';
      } else {
        labelCopyID = 'PREFERRED_SEAT';
      }
    } else if (seatUpgradeType === SEAT_UPGRADE_TYPES.EXIT_ROW_UPGRADE) {
      if (isWindowSeat) {
        labelCopyID = 'EXIT_ROW_WINDOW_SEAT';
      } else if (isAisleSeat) {
        labelCopyID = 'EXIT_ROW_AISLE_SEAT';
      } else if (isMiddleSeat) {
        labelCopyID = 'EXIT_ROW_MIDDLE_SEAT';
      } else {
        labelCopyID = 'EXIT_ROW_SEAT';
      }
    }

    return labelCopyID;
  }

  getSeatLabelSeatMap() {
    const {
      isAisleSeat,
      isWindowSeat,
      isMiddleSeat,
    } = this;

    let labelCopyID = '';

    if (isWindowSeat) {
      labelCopyID = 'SEATMAP_SEAT_TYPE_WINDOW';
    } else if (isAisleSeat) {
      labelCopyID = 'SEATMAP_SEAT_TYPE_AISLE';
    } else if (isMiddleSeat) {
      labelCopyID = 'SEATMAP_SEAT_TYPE_MIDDLE';
    }
    return labelCopyID;
  }

  getUpgradeCurrency() {
    return this.currency.currencyCode;
  }

  getUpgradeTotal() {
    return this.currency.total;
  }
}

export default SeatChoiceUpsellUIModel;
